import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { OrganisationSpecificStepsAdminComponent } from './organisations-specific-steps-admin.component';
import { TableModule } from 'primeng/table';
import { OrganisationsSpecificStepsModule } from '../organisations-specific-steps.module';

const routes: Routes = [{ path: '', component: OrganisationSpecificStepsAdminComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganisationsSpecificStepsAdminRoutingModule {}

@NgModule({
  imports: [
    OrganisationsSpecificStepsAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
    OrganisationsSpecificStepsModule,
  ],
  declarations: [OrganisationSpecificStepsAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrganisationsSpecificStepsAdminModule {}
